<template>
  <div class="div-history-evaluation">
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="date"
        label="Fecha"
        width="100"
      />
      <el-table-column
        prop="time"
        label="Hora"
        width="70"
      />
      <el-table-column
        prop="type"
        label="Tipo"
      />
      <el-table-column
          label="Creador Por">
        <template slot-scope="scope">
          <label>{{tableData[scope.$index].creator.firstName}}&nbsp;</label>
          <label>{{tableData[scope.$index].creator.lastName}}</label>
        </template>
      </el-table-column>
      <el-table-column
          label="Agenda">
        <template slot-scope="scope">
          <label>{{tableData[scope.$index].user.firstName}}&nbsp;</label>
          <label>{{tableData[scope.$index].user.lastName}}</label>
        </template>
      </el-table-column>
      <el-table-column
        label="Operación">
        <template slot-scope="scope">
          <router-link :to='`/admin/evaluations/SocialHistory/${idpatient}/${idApointment}`'>
            <el-button
              type="primary"
              size="mini"
              plain
              @click="rowSelect(scope.$index, scope.row)"
            >Visualizar</el-button>
          </router-link>
      </template>
    </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    patientId: {
      type: Number,
    },
  },
  data() {
    return {
      idpatient: '',
      idApointment: '',
      tableData: [],
      appointmentData: '',
    };
  },
  methods: {
    rowSelect(row) {
      this.idApointment = this.tableData[row].id;
      // this.appointmentData = this.tableData[date]
    },
    async getAppointments() {
      try {
        const response = await this.axios.get(`patient/appointment/social/history/${this.patientId}`);
        const { data } = response;
        if (data) {
          this.tableData = data;
          for (let i = 0; i < data.length; i++) {
            if (data[i].user == null) {
              data[i].user = 'desconocido';
            }
          }
        }
      } catch (error) {
        this.$errorNotify(error);
      }
    },
  },
  mounted() {
    this.getAppointments();
  },
  created() {
    this.idpatient = this.patientId;
  },
  watch: {
    patientId(val) {
      if (val) {
        this.getAppointments();
      }
    },
  },
};
</script>
